// 9fbef606107a605d69c0edbcd8029e5d
import COUPON_CONSTANTS from '../Coupon.constants';

export const applyCoupon = (payload) => {
  return {
    type: COUPON_CONSTANTS.APPLY_COUPON,
    payload,
  };
};

export const showLoader = () => ({
  type: COUPON_CONSTANTS.SHOW_LOADER,
});

export const hideLoader = () => ({
  type: COUPON_CONSTANTS.HIDE_LOADER,
});

export const getCouponList = (payload) => {
  return {
    type: COUPON_CONSTANTS.GET_COUPON_LIST,
    payload,
  };
};

export const getLoyaltyCouponList = (payload) => {
  return {
    type: COUPON_CONSTANTS.GET_LOYALTY_COUPON_LIST,
    payload,
  };
};

export const updateOnHoldCoupons = (payload) => {
  return {
    type: COUPON_CONSTANTS.UPDATE_COUPON_LIST_ON_HOLD,
    payload,
  };
};

export const updateExpiredCoupons = (payload) => {
  return {
    type: COUPON_CONSTANTS.UPDATE_COUPON_LIST_EXPIRED,
    payload,
  };
};

export const fromCouponTab = (payload) => {
  return {
    type: COUPON_CONSTANTS.FROM_COUPON_TAB,
    payload,
  };
};

export const fromIsApply = (payload) => {
  return {
    type: COUPON_CONSTANTS.FROM_APPLY,
    payload,
  };
};

export const getMyRewardCouponList = (payload) => {
  return {
    type: COUPON_CONSTANTS.GET_MY_REWARD_COUPON_LIST,
    payload,
  };
};
export const getCouponDetails = (payload) => {
  return {
    type: COUPON_CONSTANTS.GET_COUPON_DETAILS,
    payload,
  };
};

export const setCouponCode = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_COUPON_CODE,
    payload,
  };
};

export const setCouponDetailsError = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_COUPON_DETAILS_ERROR,
    payload,
  };
};

export const setGetCouponDetailsLoader = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_COUPON_DETAILS_LOADER,
    payload,
  };
};

export const setApplyCouponCSHLoader = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_APPLY_COUPON_CSH_LOADER,
    payload,
  };
};

export const setApplyCouponCSHError = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_APPLY_COUPON_CSH_ERROR,
    payload,
  };
};

export const resetCouponDetails = () => {
  return {
    type: COUPON_CONSTANTS.RESET_COUPON_DETAILS,
  };
};

export const setCouponDetails = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_COUPON_DETAILS,
    payload,
  };
};

export const setCouponList = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_COUPON_LIST,
    payload,
  };
};

export const setNonLoyaltyCouponList = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_NON_LOYALTY_COUPON_LIST,
    payload,
  };
};

export const setBonusPointDay = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_BONUS_POINT_DAY,
    payload,
  };
};

export const setLoyaltyBonusPointDay = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_LOYALTY_BONUS_POINT_DAY,
    payload,
  };
};

export const setBonusPointDayCouponIndex = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_BONUS_POINT_DAY_COUPON_INDEX,
    payload,
  };
};

export const getCouponTermsAndConditions = (payload) => {
  return {
    type: COUPON_CONSTANTS.GET_COUPON_TERMS_AND_CONDITIONS,
    payload,
  };
};

export const setCouponTermsAndConditions = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_COUPON_TERMS_AND_CONDITIONS,
    payload,
  };
};

export const removeCoupon = (payload) => {
  return {
    type: COUPON_CONSTANTS.REMOVE_COUPON,
    payload,
  };
};

export const setStatus = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_STATUS_COUPON,
    payload,
  };
};

export const setAppliedCOuponStatus = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_COUPON_APPLIED_STATUS,
    payload,
  };
};

export const callCouponAction = (payload) => {
  return {
    type: COUPON_CONSTANTS.CALL_COUPON_ACTION,
    payload,
  };
};

export const setError = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_ERROR,
    payload,
  };
};

export const toggleNeedHelpModalState = () => {
  return {
    type: COUPON_CONSTANTS.TOGGLE_NEED_HELP_MODAL_STATE,
  };
};

export const setNeedHelpModalState = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_NEED_HELP_MODAL_STATE,
    payload,
  };
};

export const setCouponsFetchTimestampState = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_COUPONS_FETCH_TIMESTAMP,
    payload,
  };
};

export const clearCouponTTL = () => {
  return {
    type: COUPON_CONSTANTS.CLEAR_COUPON_TTL,
  };
};

export const resetWalletAppState = () => {
  return {
    type: COUPON_CONSTANTS.RESET_COUPON_STATE,
  };
};

export const applyPlaceBucksCoupons = (payload) => {
  return {
    type: COUPON_CONSTANTS.APPLY_PLACE_BUCKS,
    payload,
  };
};

/**
 * @function resetCouponReducer
 * action creator for type: RESET_COUPON_REDUCER
 */
export const resetCouponReducer = () => {
  return {
    type: COUPON_CONSTANTS.RESET_COUPON_REDUCER,
  };
};

export const setOnHoldCoupon = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_ONHOLD_COUPON,
    payload,
  };
};

export const setLastAppliedCoupon = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_LAST_APPLIED_COUPON,
    payload,
  };
};

export const toggleMultiAddCouponLoader = (payload) => {
  return {
    type: COUPON_CONSTANTS.TOGGLE_MULTI_LOADER,
    payload,
  };
};
export const setMultiAddSuccess = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_MULTI_ADD_SUCCESS,
    payload,
  };
};

export const setOpenCouponDetailModalActn = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_OPEN_COUPON_DETAIL_MODAL,
    payload,
  };
};

export const setMultiAddCouponError = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_MULTI_ADD_ERROR,
    payload,
  };
};

export const setBenefits = (payload) => {
  return {
    type: COUPON_CONSTANTS.SET_BENEFITS,
    payload,
  };
};
